'use strict';
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

const _StarFilled = _interopRequireDefault(require('./lib/icons/StarFilled'));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

const _default = _StarFilled;
exports.default = _default;
module.exports = _default;